<template>
  <b-table class="blocks-table" :items="items" :small="true" :fields="[type, ...fields]"
    :style="{ 'border-color': color }">
    <template :slot="type" slot-scope="data">
      <span class="blocks-table__index text-uppercase" :style="{ 'background-color': color }">
        {{ items[data.index].name }}
      </span>
    </template>
      <template slot="polarity" slot-scope="data">
        {{ data.value ? 'POLAR' : 'NON-POLAR' }}
    </template>
    <template slot="solubility" slot-scope="data">
        {{ data.value ? 'SOLUBLE' : 'IN-SOLUBLE' }}
    </template>
    <template slot="aromaticity" slot-scope="data">
        {{ data.value ? 'yes' : 'no' }}
    </template>
  </b-table>
</template>

<script>

export default {
  props: ['items', 'type', 'color'],
  data() {
    return {
      fields: ['mw', 'pw', 'polarity', 'solubility',
        'heteroatoms', 'h_bond_donors', 'h_bond_acceptors', 'halogens', 'bulkiness',
        'rotatable_bonds', 'aromaticity', 'moieties'],
    };
  },
};
</script>

<style lang="scss">
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';
.blocks-table:not(:first-of-type) thead tr th:not(:first-of-type){
  opacity: 0;
}
.blocks-table:first-of-type thead tr th:not(:first-of-type){
  vertical-align: middle;
}
.blocks-table thead tr th:first-of-type{
  width: 100px;
  padding-bottom: 5px;
}
.blocks-table{
  color: $color--black;
  thead th {
    border-top: 0;
    border-color: inherit;
    border-bottom-width: 3px;
  }
  td {
    padding-top: 8px;
    border-top: none;
    vertical-align: middle;
  }
  &__index{
    margin: 0 auto;
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color--white;
  }
}
tbody:before {
    display: block;
    height:4px;
    content:"";
}
</style>



// WEBPACK FOOTER //
// src/views/Game/BuldingBlocks/Tables/Single.vue